import { signOut } from '@/shared/services/session/compat'

import { sendToNative } from '@/shared/lib/native-bridge/send'
import { confirm } from '@/shared/ui/dialog'
import { NativeBridgeEvents } from '@/shared/lib/native-bridge/types'

import type { SignOutOptions } from './types'

const AUTH_BOOTSTRAP_PREFIXES = ['/auth/', '/sign-out', '/sem-evento']

function isAuthBootstrapPath(pathname: string) {
  return AUTH_BOOTSTRAP_PREFIXES.some(
    prefix => pathname === prefix.replace(/\/$/, '') || pathname.startsWith(prefix)
  )
}

function resolvePostSignOutTarget(callbackUrl?: string): string {
  if (callbackUrl?.startsWith('/')) return callbackUrl

  if (typeof window !== 'undefined') {
    const { pathname, search } = window.location
    if (pathname && !isAuthBootstrapPath(pathname)) {
      return `${pathname}${search}`
    }
  }

  return '/'
}

export async function executeSignOut(
  inNativeAppWebView: boolean,
  options?: SignOutOptions
): Promise<void> {
  if (options?.confirm) {
    const isConfirmed = await confirm({
      title: 'Deseja sair?',
      variant: 'warning',
      confirmLabel: 'Sim, sair',
      cancelLabel: 'Cancelar'
    })

    if (!isConfirmed) return
  }

  const { callbackUrl, redirect = true } = options ?? {}
  const clearSession = () => signOut({ redirect: false }).catch(() => undefined)

  if (inNativeAppWebView) {
    sendToNative({ type: NativeBridgeEvents.SIGN_OUT })
    await clearSession()
    return
  }

  await clearSession()

  if (redirect) {
    window.location.replace(resolvePostSignOutTarget(callbackUrl))
  }
}
